import styled from 'styled-components/macro';
import { IconButton as MuiIconButton } from '@stigg-components';

export const MenuButton = styled(MuiIconButton)`
  svg {
    font-size: 22px;
  }
`;
